import { FC } from 'react';

import { LegalDetailInfo, NaturalDetailInfo } from './components';
import { ProfileType } from '../../../../../enums';
import type { ProfileWithInfo } from '../../../../../types';
import type { InfoFieldChangeHandler } from '../../../../../components';

type DetailInfoProps = {
  profile: ProfileWithInfo | undefined;
  isEditMode: boolean;
  fields: Partial<ProfileWithInfo> | null;
  fieldsHandler: InfoFieldChangeHandler;
  isLoading?: boolean;
};

export const DetailInfo: FC<DetailInfoProps> = (props) => {
  const { profile } = props;

  const profileTypeMap: Record<ProfileType, ReturnType<FC>> = {
    [ProfileType.LEGAL]: <LegalDetailInfo {...props} />,
    [ProfileType.NATURAL]: <NaturalDetailInfo {...props} />,
  };

  return profile?.type ? profileTypeMap[profile.type] : null;
};
